export const objectToQueryString = (obj: any) => {
    if (typeof obj === 'object' && Object.keys(obj).length > 0) {
        return Object.keys(obj).map((key: string) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
        })
            .join('&');
    }
    return '';
};